<div class='app-header'>
    <div class="main-header">
        <div class="left-section">
            <img src="../assets/images/indianFlag.svg" alt="menu">
            <p>{{'governmentOfIndia' | translate}}</p>
        </div>
        <div class="right-section">
            <div class="font-switcher">
                <button type="button" [ngClass]="{ 'active': activeButton === 'increase' }"
                    (click)="changeFontSize('increase')">
                    A<sup>+</sup>
                </button>
                <button type="button" [ngClass]="{ 'active': activeButton === 'reset' }"
                    (click)="changeFontSize('reset')">
                    A<sup></sup>
                </button>
                <button type="button" [ngClass]="{ 'active': activeButton === 'decrease' }"
                    (click)="changeFontSize('decrease')">
                    A<sup>-</sup>
                </button>
            </div>

            <div class="theme-switcher">
                @if(theme === 'dark'){
                <img src="../assets/images/moon.svg" alt="moon" (click)="setTheme('light')" />
                }
                @if(theme === 'light'){
                <img src="../assets/images/sun.svg" alt="sun" (click)="setTheme('dark')">
                }
            </div>

            <div class="lang-switcher" [matMenuTriggerFor]="langMenu">
                <img src="../assets/images/lang-white.svg" alt="globe">
                <p>{{selectedLanguage.translation }}</p>
                <img class="lang-arrow" src="../assets/images/dropDownArrow.svg" alt="arrow">

                <mat-menu #langMenu="matMenu" class='mat-elevation-z3' xPosition="before" >
                    @for (lang of appLanguages; track $index) {
                    <p mat-menu-item (click)="onLanguageChange(lang)">
                        {{lang.translation}} @if(lang.langCode!=='en'){({{lang.langName}})}
                        @if (lang.langCode === selectedLanguage.langCode) {
                        <img class="lang-selected" src="../assets/images/check.svg" alt="">
                        }
                    </p>
                    <mat-divider></mat-divider>
                    }
                </mat-menu>
            </div>
        </div>
    </div>
</div>
